/**
 * VITIS MEGAMENU - JavaScript
 * Per Impact Theme - Shopify
 * 
 * Funzionalità:
 * - Ritardo hover 0.5s prima di aprire (elimina flickering)
 * - Apertura in 0.1s dopo il ritardo
 * - Chiusura in 0.1s quando il mouse esce per 0.5s
 * - Algoritmo "diagonal path" per movimento diagonale
 */

;(() => {
  // Configurazione timing
  const CONFIG = {
    openDelay: 500,      // Ritardo prima di aprire (ms)
    closeDelay: 500,     // Ritardo prima di chiudere (ms)
    animationSpeed: 200  // Velocità animazione (ms) - più fluida
  }

  function init() {
    const megaMenuTriggers = document.querySelectorAll('details[is="mega-menu-disclosure"]')

    megaMenuTriggers.forEach((details) => {
      let openTimeout = null
      let closeTimeout = null
      let isOverTrigger = false
      let isOverMenu = false
      
      // Per diagonal path
      let lastMousePos = { x: 0, y: 0 }
      let menuRect = null

      const megaMenu = details.querySelector(".mega-menu")
      
      // Funzione per aprire il menu
      function openMenu() {
        details.style.setProperty('--menu-animation-duration', CONFIG.animationSpeed + 'ms')
        details.setAttribute("open", "")
      }
      
      // Funzione per chiudere il menu
      function closeMenu() {
        details.style.setProperty('--menu-animation-duration', CONFIG.animationSpeed + 'ms')
        details.removeAttribute("open")
      }
      
      // Funzione per verificare se il mouse si sta muovendo verso il menu (diagonal path)
      function isMovingTowardsMenu(currentPos) {
        if (!menuRect || !details.hasAttribute("open")) return false
        
        const menuCenter = {
          x: menuRect.left + menuRect.width / 2,
          y: menuRect.top + menuRect.height / 2
        }
        
        // Calcola la direzione del movimento
        const prevDistance = Math.hypot(lastMousePos.x - menuCenter.x, lastMousePos.y - menuCenter.y)
        const currentDistance = Math.hypot(currentPos.x - menuCenter.x, currentPos.y - menuCenter.y)
        
        // Se ci stiamo avvicinando al menu, mantienilo aperto
        return currentDistance < prevDistance
      }
      
      // Gestione hover sul trigger (voce menu principale)
      details.addEventListener("mouseenter", (e) => {
        isOverTrigger = true
        
        // Cancella eventuali timeout di chiusura
        if (closeTimeout) {
          clearTimeout(closeTimeout)
          closeTimeout = null
        }
        
        // Se il menu è già aperto, non fare nulla
        if (details.hasAttribute("open")) return
        
        // Avvia il ritardo di apertura
        openTimeout = setTimeout(() => {
          if (isOverTrigger || isOverMenu) {
            openMenu()
            // Aggiorna menuRect dopo l'apertura
            if (megaMenu) {
              setTimeout(() => {
                menuRect = megaMenu.getBoundingClientRect()
              }, 50)
            }
          }
        }, CONFIG.openDelay)
      })

      details.addEventListener("mouseleave", (e) => {
        isOverTrigger = false
        lastMousePos = { x: e.clientX, y: e.clientY }
        
        // Cancella il timeout di apertura se non siamo ancora aperti
        if (openTimeout) {
          clearTimeout(openTimeout)
          openTimeout = null
        }
        
        // Se non siamo sul menu, avvia il ritardo di chiusura
        if (!isOverMenu) {
          closeTimeout = setTimeout(() => {
            if (!isOverTrigger && !isOverMenu) {
              closeMenu()
            }
          }, CONFIG.closeDelay)
        }
      })

      if (megaMenu) {
        megaMenu.addEventListener("mouseenter", () => {
          isOverMenu = true
          menuRect = megaMenu.getBoundingClientRect()
          
          // Cancella eventuali timeout di chiusura
          if (closeTimeout) {
            clearTimeout(closeTimeout)
            closeTimeout = null
          }
        })

        megaMenu.addEventListener("mouseleave", (e) => {
          isOverMenu = false
          lastMousePos = { x: e.clientX, y: e.clientY }
          
          // Avvia il ritardo di chiusura
          closeTimeout = setTimeout(() => {
            if (!isOverTrigger && !isOverMenu) {
              closeMenu()
            }
          }, CONFIG.closeDelay)
        })
        
        // Diagonal path: traccia il movimento del mouse
        megaMenu.addEventListener("mousemove", (e) => {
          lastMousePos = { x: e.clientX, y: e.clientY }
        })
      }
      
      // Gestione globale del movimento mouse per diagonal path
      document.addEventListener("mousemove", (e) => {
        if (!details.hasAttribute("open")) return
        if (isOverTrigger || isOverMenu) return
        
        const currentPos = { x: e.clientX, y: e.clientY }
        
        // Se ci stiamo muovendo verso il menu, mantienilo aperto
        if (isMovingTowardsMenu(currentPos)) {
          if (closeTimeout) {
            clearTimeout(closeTimeout)
            closeTimeout = null
          }
          // Imposta un nuovo timeout di chiusura
          closeTimeout = setTimeout(() => {
            if (!isOverTrigger && !isOverMenu) {
              closeMenu()
            }
          }, CONFIG.closeDelay)
        }
        
        lastMousePos = currentPos
      })

      // Category switching with promo cards
      const categoryBtns = details.querySelectorAll(".vitis-megamenu__category-btn")
      const contents = details.querySelectorAll(".vitis-megamenu__content")
      const promoCards = details.querySelectorAll(".vitis-megamenu__promo-card")

      if (categoryBtns.length > 0 && contents.length > 0) {
        categoryBtns.forEach((btn) => {
          btn.addEventListener("mouseenter", () => {
            const categoryId = btn.getAttribute("data-category")

            categoryBtns.forEach((b) => b.classList.remove("is-active"))
            contents.forEach((c) => c.classList.remove("is-active"))
            promoCards.forEach((p) => p.classList.remove("is-active"))

            btn.classList.add("is-active")

            const targetContent = details.querySelector('.vitis-megamenu__content[data-content="' + categoryId + '"]')
            if (targetContent) {
              targetContent.classList.add("is-active")
            }

            const targetPromo = details.querySelector('.vitis-megamenu__promo-card[data-promo="' + categoryId + '"]')
            if (targetPromo) {
              targetPromo.classList.add("is-active")
            }
          })
        })
      }
    })
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init)
  } else {
    init()
  }

  document.addEventListener("shopify:section:load", init)
  document.addEventListener("shopify:section:unload", init)
})()
